(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Sections-video-testimoniales"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimoniales);
  } else {
    initTestimoniales();
  }

  function initTestimoniales() {
    const sections = document.querySelectorAll('.testimoniales-section');
    
    sections.forEach(section => {
      const videos = section.querySelectorAll('.testimonial-video');
      const autoplayEnabled = section.querySelector('[data-autoplay="true"]') !== null;
      const threshold = parseInt(section.dataset.autoplayThreshold) / 100 || 0.5;
      
      if (videos.length === 0) return;

      const videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            const card = video.closest('.testimonial-card');
            
            if (entry.isIntersecting) {
              if (video.dataset.loaded !== 'true') {
                video.load();
                video.dataset.loaded = 'true';
              }
              
              if (autoplayEnabled && entry.intersectionRatio >= threshold) {
                video.play().then(() => {
                  card.classList.add('is-playing');
                }).catch(err => {
                  console.log('Autoplay bloqueado:', err);
                });
              }
            } else {
              if (autoplayEnabled) {
                video.pause();
                card.classList.remove('is-playing');
              }
            }
          });
        },
        {
          rootMargin: '50px',
          threshold: [0, 0.1, 0.25, 0.5, 0.75, 1]
        }
      );

      videos.forEach((video) => {
        videoObserver.observe(video);
        const card = video.closest('.testimonial-card');

        setupSoundToggle(video, card);
        setupManualControls(video, card);

        video.addEventListener('error', function() {
          const placeholder = document.createElement('div');
          placeholder.className = 'video-error';
          placeholder.textContent = 'Error al cargar video';
          placeholder.style.cssText = 'display:flex;align-items:center;justify-content:center;height:100%;background:#f5f5f5;color:#999;font-size:14px;';
          video.parentNode.replaceChild(placeholder, video);
        });
      });
    });
  }

  function setupSoundToggle(video, card) {
    const soundToggle = card.querySelector('.sound-toggle');
    if (!soundToggle) return;

    const mutedIcon = soundToggle.querySelector('.sound-icon--muted');
    const unmutedIcon = soundToggle.querySelector('.sound-icon--unmuted');

    soundToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      
      if (video.muted) {
        video.muted = false;
        mutedIcon.style.display = 'none';
        unmutedIcon.style.display = 'block';
      } else {
        video.muted = true;
        mutedIcon.style.display = 'block';
        unmutedIcon.style.display = 'none';
      }
    });
  }

  function setupManualControls(video, card) {
    card.addEventListener('click', function(e) {
      if (e.target.closest('.video-cta') || e.target.closest('.sound-toggle')) {
        return;
      }

      if (video.paused) {
        video.play().then(() => {
          card.classList.add('is-playing');
        }).catch(err => {
          console.log('Error al reproducir:', err);
        });
      } else {
        video.pause();
        card.classList.remove('is-playing');
      }
    });
  }

  document.addEventListener('visibilitychange', function() {
    if (document.hidden) {
      document.querySelectorAll('.testimonial-video').forEach(v => {
        v.pause();
        v.closest('.testimonial-card').classList.remove('is-playing');
      });
    }
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
